// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5c9042f3","453":"8d8ade4c","455":"8a02e53e","977":"1f2668e6"}[chunkId] + ".chunk.js";
};